export default "__VITE_ASSET__BvFwbW54__"